module.exports = __webpack_public_path__ + "img/lowRisk.e7b04a80.png";